import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { combineLatest, map, Observable } from 'rxjs';
import { Logger, OrganizationService } from 'src/app/@shared';
import { OfferPromo, PromoDomain, OfferPromoService } from '../..';
import { Status } from '../../models/offer-promo-status';
import { AuthorizeControlService } from 'pr1-ui-components';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

const log = new Logger('OfferListCardsComponent');

@Component({
  selector: 'app-offer-list-cards',
  templateUrl: './offer-list-cards.component.html',
  styleUrls: ['./offer-list-cards.component.scss'],
})
export class OfferListCardsComponent<
  TOfferPromo extends OfferPromo,
  TPromoDomain extends PromoDomain<OfferPromo>
> implements OnInit {
  private assetsUrl: string = '';
  form = new FormGroup({
    versions: new FormArray([])
  });
  offersList: any;
  viewModel$ = combineLatest([
    this.offerpromoService.getoffersPromos$,
    this.offerpromoService.isLoading$,
    this.offerpromoService.totalRecords$,
    this.offerpromoService.page$,
    this.organizationService.assetsUrl$,
  ]).pipe(
    map(([offers, isLoading, totalRecords, page, assetsUrl]) => {
      if (offers.length == 0 && page.pageIndex > 0) {
        page.previousPageIndex = 0;
        page.pageIndex = 0;
        this.offerpromoService.page(page);
        this.offerpromoService.reload();
      }
      this.form = new FormGroup({
        versions: new FormArray([])
      });
      offers.map(x => this.addVersion(x));
      this.assetsUrl = assetsUrl;
      return { offers, isLoading, totalRecords, page, assetsUrl };
    })
  );
  offerpromosList: TPromoDomain[] = [];
  assetsUrl$: Observable<string> = this.organizationService.assetsUrl$;
  selection = new SelectionModel<TPromoDomain>(true, []);
  versionsList: any[] = [];


  constructor(
    private offerpromoService: OfferPromoService<TOfferPromo, TPromoDomain>,
    private organizationService: OrganizationService,
    private authorizationService: AuthorizeControlService
  ) { }

  ngOnInit(): void {

  }

  onSort(sortState: Sort): void {
    this.offerpromoService.sort(sortState);
  }

  onPage(pageEvent: PageEvent): void {
    this.selection.clear();
    this.offerpromoService.page(pageEvent);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.offerpromosList.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.offerpromosList.forEach((row) => this.selection.select(row));
  }

  public getSelectedSectionRecords() {
    return this.selection.selected;
  }

  public clearSelection() {
    this.selection.clear();
  }

  updateStatus(status: Status) {
    let selectedRecordsDetails: any;
    selectedRecordsDetails = JSON.parse(
      JSON.stringify(this.getSelectedSectionRecords())
    );
    this.updateRecordsStatus(selectedRecordsDetails, status);
  }

  updateTableStatus(status: Status, row: any) {
    let selectedRecordsDetails: any;
    selectedRecordsDetails = [JSON.parse(JSON.stringify(row))];
    this.updateRecordsStatus(selectedRecordsDetails, status);
  }

  updateRecordsStatus(selectedRecordsDetails: Array<any>, status: any) {
    if (selectedRecordsDetails && selectedRecordsDetails.length > 0) {
      selectedRecordsDetails = selectedRecordsDetails.map((x: any) => {
        x.Status = status;
        return x;
      });
      this.offerpromoService.updateStatus(selectedRecordsDetails).subscribe({
        next: () => {
          this.offerpromoService.reload();
          this.clearSelection();
          this.offerpromoService.updateRecordStatus(new Date());
        },
      });
    }
  }

  public getImageSrc(assets: any) {
    let imagesrc = '';
    if (assets.Type === 'application/pdf') {
      imagesrc = './assets/images/pdf.png';
    } else if (assets.Type.indexOf('audio') > -1) {
      imagesrc = './assets/images/mp3.jpg';
    } else if (assets.Type.indexOf('video') > -1) {
      imagesrc = './assets/images/mp4.png';
    } else if (assets.Type.indexOf('text') > -1) {
      imagesrc = './assets/images/text.png';
    } else {
      imagesrc = this.assetsUrl + '/' + assets.FileName;
    }
    return imagesrc;
  }

  canEdit(): boolean {
    const hasAccess = this.authorizationService.checkAccess('edit||offermang');
    return hasAccess;
  }

  getSelectedVersionDetail(event: any, offer: any) {
    offer.activeItem = false;
    offer.Versions = offer.Versions.map((x: any) => { x.activeItem = false; return x; });
    if (event.value && offer) {
      if (event.value.Id === offer.DomainId) {
        offer.activeItem = true;
        return;
      }
      const offerVersion = offer.Versions.find((x: any) => x.Id === event.value.Id);
      if (offerVersion) {
        offerVersion.activeItem = true;
      }
    }
  }


  getActiveOffer(offer: any) {
    if (offer.activeItem) {
      return offer.Versions[0];
    }
    const versionOffer = offer.Versions.find((x: any) => x.activeItem === true);
    if (!versionOffer) {
      return offer.Versions[0];
    }
    return versionOffer;
  }

  get versions(): FormArray {
    return this.form.get('versions') as FormArray;
  }
  addVersion(offer: any) {
    if (this.versions) {
      this.versions.push(new FormControl((offer.Versions && offer.Versions.length > 0 ) ? offer.Versions[0] : null));
    }
  }
}
